import React from 'react';

import { useCan } from '../hooks/use-can.hook';
import { PolicyWithParams } from '../types';

type CanProps = {
  I: PolicyWithParams;
  children: React.ReactNode;
  fallback?: React.ReactNode;
};

export const Can = ({ I, children, fallback }: CanProps) => {
  const isUserPermittedTo = useCan();
  const isAllowed = isUserPermittedTo(I.policy, I.params);

  if (isAllowed) {
    return children;
  }

  if (fallback) {
    return fallback;
  }

  return null;
};
